import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ApiService } from '../services/api.service';
import { Storage } from '@ionic/storage-angular';
import { environment } from 'src/environments/environment';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { User } from 'src/assets/data/interfaces/interfaces-service';
import { FontAwesomeService } from '../services/fontawesome.service';

@Component({
  selector: 'app-app-update',
  templateUrl: './app-update.page.html',
  styleUrls: ['./app-update.page.scss'],
})
export class AppUpdatePage implements OnInit {

  subscriptions: Subscription[] = [];
  version;
  onlineVersion: any;
  fechaCabecera: any;
  user: User = {
    username: null,
    userId: null,
    clientes: null,
    roles: null,
  };

  errorMessage: string;

  constructor(
    public apiService: ApiService,
    public modalCtrl: ModalController,
    public dialog: MatDialog,
    public router: Router,
    public platform: Platform,
    public storage: Storage,
    public activatedRoute: ActivatedRoute,
    public faService: FontAwesomeService,
  ) {
    this.version = environment.version;
  }

  ngOnInit() { }

  ionViewWillEnter() {
    this.storage.get("user").then((data: { username: any; userId: any; clientes: any; roles: any; }) => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.onlineVersion = params['nuevaVersion']
    });
    // this.subscriptions.push(this.apiService.getApkVersion().subscribe(result => {
    //   this.onlineVersion = result;
    // }, error => {
    //   console.log("Error de busqueda de version de apk. ", error);
    // }));
  }

  ionViewDidLeave() {
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
  }

  getNewVersion() {
    this.apiService.getApkRoute().subscribe(result => {
      if (result) {
        this.errorMessage = null;
        let browser = new InAppBrowser().create(result + '/app-comprador.apk', '_system');
        browser.close();
        try { navigator['app'].exitApp(); } // Se cierra automaticamente la app
        catch (error) { console.log("Error de salida forzada de la app. ", error); }
      }
    }, error => {
      console.log("error en la recepcion de la ruta de la apk");
      this.errorMessage = "Fallo en la recepción de ruta de apk."
    })
  }
}
